export default __webpack_public_path__ + "static/media/dna2.f05f90b8.png";